__turbopack_context__.v({
  "container": "FW-ulW_container",
  "productActions": "FW-ulW_productActions",
  "productContent": "FW-ulW_productContent",
  "productDescription": "FW-ulW_productDescription",
  "productItem": "FW-ulW_productItem",
  "productTitle": "FW-ulW_productTitle",
  "root": "FW-ulW_root",
});
